(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[481],{

/***/ 4325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ e_signature; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/Layout/index.ts + 1 modules
var Layout = __webpack_require__(5109);
// EXTERNAL MODULE: ./components/_OldDesign/header.tsx + 1 modules
var header = __webpack_require__(6627);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./components/eSignature/ProductDefinitionSection/ProductDefinitionSection.module.scss
var ProductDefinitionSection_module = __webpack_require__(6146);
var ProductDefinitionSection_module_default = /*#__PURE__*/__webpack_require__.n(ProductDefinitionSection_module);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 109 modules
var motion = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/Common/index.ts + 2 modules
var Common = __webpack_require__(4565);
// EXTERNAL MODULE: ./utils/translate.ts
var translate = __webpack_require__(954);
// EXTERNAL MODULE: ./components/Contexts/LocaleContext.tsx
var LocaleContext = __webpack_require__(5314);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/eSignature/ProductDefinitionSection/ProductDefinitionSection.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var ProductDefinitionSection_hidden = {
  opacity: 0,
  y: 20
};
var visible = {
  opacity: 1,
  y: 0
};
var transition = {
  duration: 1
};

var ProductDefinitionSection = function ProductDefinitionSection(_ref) {
  var click = _ref.click;

  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang;

  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    id: "e-signature",
    className: "relative w-full h-fit pt-[3.5rem] bg-darkBlue",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "absolute top-0 w-screen h-full md:hidden ".concat((ProductDefinitionSection_module_default()).filterBackground),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "absolute bottom-0 w-full",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "/images/e-signature/bg2.webp",
          alt: "bg",
          width: 375,
          height: 480,
          sizes: "100vw",
          style: {
            width: '100%'
          }
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "hidden w-screen md:block lg:hidden",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: "/images/e-signature/bg2lg.webp",
        alt: "bg",
        width: 744,
        height: 360,
        sizes: "100vw",
        style: {
          width: '100%'
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "hidden w-screen lg:block md:hidden",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: "/images/e-signature/bg2xl.webp",
        alt: "bg",
        width: 1440,
        height: 396,
        sizes: "100vw",
        style: {
          width: '100%'
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "md:absolute w-full md:h-full top-0 md:pt-[3.5rem] z-10",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "relative h-full flex flex-col justify-center items-center pt-8 md:pt-0 pb-40 md:pb-0",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-full flex flex-col lg:flex-row lg:gap-6 lg:items-center text-white px-4 md:px-12 lg:px-6 xl:px-[8.875rem] xxl:px-[8.875rem] lg:container lg:mx-auto",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "md:w-[80%]",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.h1 */.E.h1, {
              className: "text-h4Bold md:text-h2Bold lg:text-h1Bold xxl:text-dSmallBold gradient-head-large py-1",
              initial: ProductDefinitionSection_hidden,
              animate: visible,
              transition: transition,
              children: lang === 'en' ? 'What is e-Signature?' : 'e-Signature คืออะไร?'
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "w-[160px] md:w-[205px] lg:w-[228px] xxl:w-[250px] my-3 lg:my-2 xl:my-5",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                className: "bg-[#f0f3f5] h-0.5 rounded",
                initial: _objectSpread(_objectSpread({}, ProductDefinitionSection_hidden), {}, {
                  width: 0
                }),
                animate: _objectSpread(_objectSpread({}, visible), {}, {
                  width: '100%'
                }),
                transition: _objectSpread({}, transition)
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.p */.E.p, {
              className: "text-p3Regular md:text-p2Regular lg:text-p3Regular xl:text-p2Regular 2xl:text-p1Regular text-white py-1 md:w-[80%] ".concat(lang === 'en' ? 'lg:w-[80%]' : 'lg:w-full'),
              initial: ProductDefinitionSection_hidden,
              animate: visible,
              transition: _objectSpread(_objectSpread({}, transition), {}, {
                delay: 0.25
              }),
              children: lang === 'en' ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: ["Unlock your organization's", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "font-semibold",
                  children: "digital transformation"
                }), ' ', "with our best-in-class", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "font-semibold",
                  children: "e-Signature system."
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Streamline document signing processes,", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "font-semibold",
                  children: "eliminate paper-based transactions,"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "and enhance operational agility. Ensure full compliance with", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "font-semibold",
                  children: "the Electronic Transactions Act"
                }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
                  className: "hidden md:block"
                }), "and the ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "font-semibold",
                  children: "ETDA"
                }), ' ', "standards for secure and legally recognized digital signatures."]
              }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: ["\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E01\u0E32\u0E23\u0E17\u0E33", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "font-semibold",
                  children: "Digital Transformation"
                }), ' ', "\u0E43\u0E2B\u0E49\u0E01\u0E31\u0E1A\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E14\u0E49\u0E27\u0E22", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: "font-semibold",
                  children: ["\u0E23\u0E30\u0E1A\u0E1A\u0E25\u0E07\u0E25\u0E32\u0E22\u0E21\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E2D\u0E34\u0E40\u0E25\u0E47\u0E01\u0E17\u0E23\u0E2D\u0E19\u0E34\u0E01\u0E2A\u0E4C", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "whitespace-nowrap",
                    children: "(e-Signature)"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E27\u0E32\u0E21\u0E04\u0E25\u0E48\u0E2D\u0E07\u0E15\u0E31\u0E27\u0E43\u0E19\u0E01\u0E32\u0E23\u0E25\u0E07\u0E19\u0E32\u0E21\u0E1A\u0E19\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "font-semibold",
                  children: "\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E01\u0E23\u0E30\u0E14\u0E32\u0E29\u0E2D\u0E35\u0E01\u0E15\u0E48\u0E2D\u0E44\u0E1B"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E15\u0E32\u0E21", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "font-semibold",
                  children: "\u0E1E.\u0E23.\u0E1A.\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E17\u0E32\u0E07\u0E2D\u0E34\u0E40\u0E25\u0E47\u0E01\u0E17\u0E23\u0E2D\u0E19\u0E34\u0E01\u0E2A\u0E4C"
                }), ' ', "\u0E41\u0E25\u0E30", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "font-semibold",
                  children: "\u0E21\u0E32\u0E15\u0E23\u0E10\u0E32\u0E19\u0E2A\u0E33\u0E19\u0E31\u0E01\u0E07\u0E32\u0E19\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E17\u0E32\u0E07\u0E2D\u0E34\u0E40\u0E25\u0E47\u0E01\u0E17\u0E23\u0E2D\u0E19\u0E34\u0E01\u0E2A\u0E4C (ETDA)"
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "mt-5 lg:mt-3",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Common/* Button */.z, {
                id: "contact-us-esignature",
                icon: "/icons/speech.svg",
                text: (0,translate/* translate2 */.n7)('ติดต่อเรา', 'CONTACT US', lang),
                className: "text-sm border border-white",
                onClick: click
              })
            })]
          })
        })
      })
    })]
  });
};

/* harmony default export */ var ProductDefinitionSection_ProductDefinitionSection = (ProductDefinitionSection);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-in-view.mjs + 3 modules
var use_in_view = __webpack_require__(7037);
;// CONCATENATED MODULE: ./components/eSignature/Compare/Compare.tsx


function Compare_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Compare_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Compare_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Compare_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var hiddenX = {
  opacity: 0,
  x: 20
};
var visibleX = {
  opacity: 1,
  x: 0
};
var hiddenY = {
  opacity: 0,
  y: 20
};
var visibleY = {
  opacity: 1,
  y: 0
};
var Compare_transition = {
  duration: 0.5
};

var Compare = function Compare(_ref) {
  var header = _ref.header,
      expand = _ref.expand,
      section = _ref.section,
      desc = _ref.desc,
      src = _ref.src,
      tagColor = _ref.tagColor,
      _ref$flexRowReverse = _ref.flexRowReverse,
      flexRowReverse = _ref$flexRowReverse === void 0 ? false : _ref$flexRowReverse;
  var ref = (0,react.useRef)(null);
  var isInView = (0,use_in_view/* useInView */.Y)(ref, {
    amount: 0.5,
    once: true
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    className: "p-4 mb-4 lg:mx-2 bg-[#F8F8F8] w-full rounded",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative w-full rounded md:hidden lg:block",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative flex flex-col lg:flex-row justify-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "relative w-fit mx-auto lg:mx-0 text-darkBlue self-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "relative text-p2Semibold px-3 w-fit mx-auto",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "absolute top-0 left-0 w-[3px] h-full rounded",
              style: {
                background: tagColor
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.p */.E.p, {
              initial: hiddenY,
              animate: isInView ? visibleY : hiddenY,
              transition: Compare_objectSpread(Compare_objectSpread({}, Compare_transition), {}, {
                delay: 0.3
              }),
              children: header
            })]
          }), expand && /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.p */.E.p, {
            className: "lg:absolute text-p4Regular pt-1 lg:pl-3 lg:w-[150%] text-center lg:text-left",
            initial: hiddenY,
            animate: isInView ? visibleY : hiddenY,
            transition: Compare_objectSpread(Compare_objectSpread({}, Compare_transition), {}, {
              delay: 0.5
            }),
            children: expand
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "relative text-p2Semibold whitespace-nowrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.p */.E.p, {
            className: "px-[13px] py-1 rounded-2xl bg-[#E2EEFF] w-fit mt-6 lg:my-0 mx-auto",
            initial: hiddenY,
            animate: isInView ? visibleY : hiddenY,
            transition: Compare_objectSpread(Compare_objectSpread({}, Compare_transition), {}, {
              delay: 0.35
            }),
            children: section
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "relative flex items-center my-5 h-[200px]",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
          className: "w-fit mx-auto",
          initial: hiddenY,
          animate: isInView ? visibleY : hiddenY,
          transition: Compare_objectSpread(Compare_objectSpread({}, Compare_transition), {}, {
            delay: 0.5
          }),
          children: src
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        className: "relative w-full mt-4 text-p3Regular text-black",
        initial: hiddenY,
        animate: isInView ? visibleY : hiddenY,
        transition: Compare_objectSpread(Compare_objectSpread({}, Compare_transition), {}, {
          delay: 0.7
        }),
        children: desc
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "hidden relative w-full md:block lg:hidden",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative flex ".concat(flexRowReverse && 'flex-row-reverse'),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "relative flex h-[166px]",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
            className: "w-fit",
            initial: {
              opacity: 0,
              x: flexRowReverse ? 20 : -20
            },
            animate: isInView ? visibleX : {
              opacity: 0,
              x: flexRowReverse ? 20 : -20
            },
            transition: Compare_objectSpread(Compare_objectSpread({}, Compare_transition), {}, {
              delay: 0.3
            }),
            children: src
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "relative flex flex-col w-[80%] px-3",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "relative flex text-darkBlue mb-5",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "pt-1",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                className: "relative text-p2Semibold px-3",
                initial: hiddenX,
                animate: isInView ? visibleX : hiddenX,
                transition: Compare_objectSpread(Compare_objectSpread({}, Compare_transition), {}, {
                  delay: 0.3
                }),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "absolute top-0 left-0 w-[3px] h-full rounded",
                  style: {
                    background: tagColor
                  }
                }), header]
              }), expand && /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.p */.E.p, {
                className: "absolute text-p4Regular pt-2 pl-3 w-[150%]",
                initial: hiddenX,
                animate: isInView ? visibleX : hiddenX,
                transition: Compare_objectSpread(Compare_objectSpread({}, Compare_transition), {}, {
                  delay: 0.5
                }),
                children: expand
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "relative text-p2Semibold whitespace-nowrap",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.p */.E.p, {
                className: "px-[13px] py-1 rounded-2xl bg-[#E2EEFF] w-fit",
                initial: hiddenY,
                animate: isInView ? visibleY : hiddenY,
                transition: Compare_objectSpread(Compare_objectSpread({}, Compare_transition), {}, {
                  delay: 0.35
                }),
                children: section
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
            className: "relative w-full mt-4 text-p3Regular text-black",
            initial: {
              opacity: 0
            },
            animate: isInView ? {
              opacity: 1
            } : {
              opacity: 0
            },
            transition: Compare_objectSpread(Compare_objectSpread({}, Compare_transition), {}, {
              delay: 0.5
            }),
            children: desc
          })]
        })]
      })
    })]
  });
};

/* harmony default export */ var Compare_Compare = (Compare);
// EXTERNAL MODULE: ./components/Contexts/TailwindBreakpointContext.tsx + 4 modules
var TailwindBreakpointContext = __webpack_require__(9806);
;// CONCATENATED MODULE: ./components/eSignature/CompareSection/CompareSection.tsx










var CompareSection = function CompareSection() {
  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang;

  var _useTailwindBreakpoin = (0,TailwindBreakpointContext/* useTailwindBreakpoint */._)(),
      screenWidth = _useTailwindBreakpoin.screenWidth;

  var _useState = (0,react.useState)(null),
      initWidth = _useState[0],
      setInitWidth = _useState[1];

  (0,react.useEffect)(function () {
    setInitWidth(window.innerWidth);
  }, []);
  (0,react.useEffect)(function () {
    if (screenWidth) {
      setInitWidth(null);
    }
  }, [screenWidth]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    id: "compare",
    className: "relative w-full",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "Container relative text-h5MobileBold lg:text-h5Bold gradient-head text-center py-8",
      children: "e-Signature vs. Digital Signature"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: initWidth >= 1024 || screenWidth >= 1024 ? 'Container' : 'px-4 md:px-12',
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative flex flex-col lg:flex-row justify-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Compare_Compare, {
          header: (0,translate/* translate2 */.n7)('ลายมือชื่ออิเล็กทรอนิกส์ทั่วไป', 'Electronic signature', lang),
          section: (0,translate/* translate2 */.n7)('มาตรา 9', 'Section 9', lang),
          desc: (0,translate/* translate2 */.n7)( /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: ["\u0E40\u0E1B\u0E47\u0E19\u0E25\u0E32\u0E22\u0E21\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E43\u0E19\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E43\u0E14\u0E46 \u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E08\u0E30\u0E40\u0E1B\u0E47\u0E19\u0E2D\u0E31\u0E01\u0E29\u0E23, \u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02, \u0E40\u0E2A\u0E35\u0E22\u0E07 \u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E31\u0E0D\u0E25\u0E31\u0E01\u0E29\u0E13\u0E4C\u0E2D\u0E37\u0E48\u0E19\u0E43\u0E14\u0E17\u0E35\u0E48\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E02\u0E36\u0E49\u0E19\u0E43\u0E2B\u0E49\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E2D\u0E34\u0E40\u0E25\u0E47\u0E01\u0E17\u0E23\u0E2D\u0E19\u0E34\u0E01\u0E2A\u0E4C \u0E17\u0E35\u0E48\u0E21\u0E35\u0E25\u0E31\u0E01\u0E29\u0E13\u0E30\u0E15\u0E32\u0E21\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E43\u0E19", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "text-p3Semibold text-[#0D375B]",
              children: "\u0E21\u0E32\u0E15\u0E23\u0E32 9"
            }), ' ', "\u0E41\u0E2B\u0E48\u0E07\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E27\u0E48\u0E32\u0E14\u0E49\u0E27\u0E22\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E17\u0E32\u0E07\u0E2D\u0E34\u0E40\u0E25\u0E47\u0E01\u0E17\u0E23\u0E2D\u0E19\u0E34\u0E01\u0E2A\u0E4C"]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: ["A digital signature that meets the characteristics specified in", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "text-p3Semibold text-[#0D375B]",
              children: "Section 26"
            }), ' ', "and is backed by a certificate issued by a Certification Authority (CA) supports electronic signatures as outlined in Section 28 of the Electronic Transactions Act. This ensures the ability to verify document modifications with the Certification Authority serving as a trusted intermediary."]
          }), lang),
          src: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "images/e-signature/compare1.webp",
            alt: "\u0E25\u0E32\u0E22\u0E21\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E2D\u0E34\u0E40\u0E25\u0E47\u0E01\u0E17\u0E23\u0E2D\u0E19\u0E34\u0E01\u0E2A\u0E4C\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B",
            width: 334,
            height: 200
          }),
          tagColor: "#E84143"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Compare_Compare, {
          header: (0,translate/* translate2 */.n7)('ลายมือชื่ออิเล็กทรอนิกส์ที่เชื่อถือได้', 'Digital Signature', lang),
          section: (0,translate/* translate2 */.n7)('มาตรา 26', 'Section 26', lang),
          desc: (0,translate/* translate2 */.n7)( /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: ["\u0E40\u0E1B\u0E47\u0E19\u0E25\u0E32\u0E22\u0E21\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E2D\u0E34\u0E40\u0E25\u0E47\u0E01\u0E17\u0E23\u0E2D\u0E19\u0E34\u0E01\u0E2A\u0E4C\u0E17\u0E35\u0E48\u0E21\u0E35\u0E25\u0E31\u0E01\u0E29\u0E13\u0E30\u0E15\u0E32\u0E21\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E43\u0E19", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "text-p3Semibold text-[#0D375B]",
              children: "\u0E21\u0E32\u0E15\u0E23\u0E32 26"
            }), ' ', "\u0E41\u0E2B\u0E48\u0E07\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E27\u0E48\u0E32\u0E14\u0E49\u0E27\u0E22\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E17\u0E32\u0E07\u0E2D\u0E34\u0E40\u0E25\u0E47\u0E01\u0E17\u0E23\u0E2D\u0E19\u0E34\u0E01\u0E2A\u0E4C \u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E08\u0E32\u0E01\u0E01\u0E23\u0E30\u0E1A\u0E27\u0E19\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E23\u0E2B\u0E31\u0E2A\u0E25\u0E31\u0E1A (Encrypt) \u0E0A\u0E48\u0E27\u0E22\u0E43\u0E2B\u0E49\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E15\u0E31\u0E27\u0E15\u0E19\u0E40\u0E08\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E25\u0E32\u0E22\u0E21\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E41\u0E25\u0E30\u0E15\u0E23\u0E27\u0E08\u0E1E\u0E1A\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E02\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E41\u0E25\u0E30\u0E25\u0E32\u0E22\u0E21\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E44\u0E14\u0E49 \u0E17\u0E33\u0E43\u0E2B\u0E49\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E04\u0E27\u0E32\u0E21\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E08\u0E32\u0E01\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E41\u0E2A\u0E14\u0E07\u0E40\u0E08\u0E15\u0E19\u0E32\u0E43\u0E19\u0E01\u0E32\u0E23\u0E25\u0E07\u0E25\u0E32\u0E22\u0E21\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E44\u0E14\u0E49"]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: ["A digital signature complies with the characteristics specified in", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "text-p3Semibold text-[#0D375B]",
              children: "Section 26"
            }), ' ', "of the Electronic Transactions Act. It is generated through data encryption, ensuring the authentication of the signature's owner and detecting any alterations to the document. As a result, it prevents the signer from denying responsibility for the content of the signed document."]
          }), lang),
          src: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "images/e-signature/compare2.webp",
            alt: "\u0E25\u0E32\u0E22\u0E21\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E2D\u0E34\u0E40\u0E25\u0E47\u0E01\u0E17\u0E23\u0E2D\u0E19\u0E34\u0E01\u0E2A\u0E4C\u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E16\u0E37\u0E2D\u0E44\u0E14\u0E49",
            width: 403,
            height: 200
          }),
          tagColor: "#29ADCE",
          flexRowReverse: true
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Compare_Compare, {
          header: (0,translate/* translate2 */.n7)('ลายมือชื่ออิเล็กทรอนิกส์ที่เชื่อถือได้', 'Digital Signature', lang),
          expand: (0,translate/* translate2 */.n7)('ซึ่งใช้ใบรับรองโดยผู้ให้บริการออกใบรับรอง', 'which uses a certificate provided by a certificate authority', lang),
          section: (0,translate/* translate2 */.n7)('มาตรา 28', 'Section 28', lang),
          desc: (0,translate/* translate2 */.n7)( /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: ["\u0E40\u0E1B\u0E47\u0E19\u0E25\u0E32\u0E22\u0E21\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E2D\u0E34\u0E40\u0E25\u0E47\u0E01\u0E17\u0E23\u0E2D\u0E19\u0E34\u0E01\u0E2A\u0E4C\u0E17\u0E35\u0E48\u0E21\u0E35\u0E25\u0E31\u0E01\u0E29\u0E13\u0E30\u0E15\u0E32\u0E21\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E43\u0E19", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "text-p3Semibold text-[#0D375B]",
              children: "\u0E21\u0E32\u0E15\u0E23\u0E32 26"
            }), ' ', "\u0E41\u0E25\u0E30\u0E2D\u0E32\u0E28\u0E31\u0E22\u0E43\u0E1A\u0E23\u0E31\u0E1A\u0E23\u0E2D\u0E07\u0E17\u0E35\u0E48\u0E2D\u0E2D\u0E01\u0E42\u0E14\u0E22\u0E1C\u0E39\u0E49\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E43\u0E1A\u0E23\u0E31\u0E1A\u0E23\u0E2D\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E25\u0E32\u0E22\u0E21\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E2D\u0E34\u0E40\u0E25\u0E47\u0E01\u0E17\u0E23\u0E2D\u0E19\u0E34\u0E01\u0E2A\u0E4C\u0E15\u0E32\u0E21\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E43\u0E19", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "text-p3Semibold text-[#0D375B]",
              children: "\u0E21\u0E32\u0E15\u0E23\u0E32 28"
            }), ' ', "\u0E41\u0E2B\u0E48\u0E07\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E27\u0E48\u0E32\u0E14\u0E49\u0E27\u0E22\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E17\u0E32\u0E07\u0E2D\u0E34\u0E40\u0E25\u0E47\u0E01\u0E17\u0E23\u0E2D\u0E19\u0E34\u0E01\u0E2A\u0E4C \u0E14\u0E31\u0E07\u0E19\u0E31\u0E49\u0E19\u0E08\u0E36\u0E07\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E19\u0E35\u0E49\u0E44\u0E14\u0E49\u0E42\u0E14\u0E22\u0E21\u0E35\u0E1C\u0E39\u0E49\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E43\u0E1A\u0E23\u0E31\u0E1A\u0E23\u0E2D\u0E07 (Certificatation Authority : CA) \u0E40\u0E1B\u0E47\u0E19\u0E15\u0E31\u0E27\u0E01\u0E25\u0E32\u0E07"]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: ["A digital signature that meets the characteristics specified in", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "text-p3Semibold text-[#0D375B]",
              children: "Section 26"
            }), ' ', "and is backed by a certificate issued by a Certification Authority (CA) supports electronic signatures as outlined in", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "text-p3Semibold text-[#0D375B]",
              children: "Section 28"
            }), ' ', "of the Electronic Transactions Act. This ensures the ability to verify document modifications with the Certification Authority serving as a trusted intermediary."]
          }), lang),
          src: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: lang === 'en' ? 'images/e-signature/compare3-eng.webp' : 'images/e-signature/compare3.webp',
            alt: "\u0E25\u0E32\u0E22\u0E21\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E2D\u0E34\u0E40\u0E25\u0E47\u0E01\u0E17\u0E23\u0E2D\u0E19\u0E34\u0E01\u0E2A\u0E4C\u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E16\u0E37\u0E2D\u0E44\u0E14\u0E49",
            width: 325.82,
            height: 200
          }),
          tagColor: "#0D375B"
        })]
      })
    })]
  });
};

/* harmony default export */ var CompareSection_CompareSection = (CompareSection);
;// CONCATENATED MODULE: ./components/eSignature/CompareSection/index.ts

// EXTERNAL MODULE: ./components/Icons/index.ts + 9 modules
var Icons = __webpack_require__(9954);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/animation/hooks/use-animation.mjs + 1 modules
var use_animation = __webpack_require__(2233);
;// CONCATENATED MODULE: ./components/eSignature/Usage/Usage.tsx











var Usage = function Usage() {
  var _useTailwindBreakpoin = (0,TailwindBreakpointContext/* useTailwindBreakpoint */._)(),
      screenWidth = _useTailwindBreakpoin.screenWidth;

  var _useState = (0,react.useState)(null),
      initWidth = _useState[0],
      setInitWidth = _useState[1];

  var _useState2 = (0,react.useState)(false),
      expand = _useState2[0],
      setExpand = _useState2[1];

  var animateChevron = (0,use_animation/* useAnimation */._)();
  var ref = (0,react.useRef)();
  var isInView = (0,use_in_view/* useInView */.Y)(ref, {
    amount: 0.5,
    once: true
  });

  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang;

  (0,react.useEffect)(function () {
    setInitWidth(window.innerWidth);
  }, []);
  (0,react.useEffect)(function () {
    if (screenWidth) {
      setInitWidth(null);
    }
  }, [screenWidth]);
  (0,react.useEffect)(function () {
    animateChevron.start({
      rotate: expand ? 180 : 0,
      transition: {
        duration: 0.2
      }
    });
  }, [expand]);

  var expandContent = function expandContent() {
    setExpand(!expand);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    id: "usage",
    className: initWidth >= 1024 || screenWidth >= 1024 ? 'Container flex' : 'flex',
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      ref: ref,
      className: "p-4 mx-4 md:mx-12 lg:mx-2 bg-[#F8F8F8] w-full rounded",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "relative flex flex-col md:flex-row",
        children: usages.map(function (usage) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "md:flex-1 lg:flex-auto ".concat(usage.customClass),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: initWidth >= 940 || screenWidth >= 940 ? 'flex items-center flex-wrap' : 'flex flex-col justify-center',
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex justify-center items-center mt-2",
                children: [usage.icon, /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                  className: "text-p2Semibold text-darkBlue px-3",
                  initial: {
                    opacity: 0,
                    x: 20
                  },
                  animate: isInView ? {
                    opacity: 1,
                    x: 0
                  } : {
                    opacity: 0,
                    x: 20
                  },
                  transition: {
                    duration: 0.5,
                    delay: 0.3
                  },
                  children: (0,translate/* translate2 */.n7)( /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: ["\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E44\u0E2B\u0E23\u0E48\u0E17\u0E35\u0E48\u0E04\u0E27\u0E23\u0E43\u0E0A\u0E49 ", usage.sectionTH, "?"]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: ["When is using ", usage.section, " suitable?"]
                  }), lang)
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
              children: (lang === 'en' ? usage.detail : usage.detailTH).map(function (item, i) {
                return initWidth >= 768 || screenWidth >= 768 || !item.collapse ? /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.li */.E.li, {
                  initial: "initial",
                  animate: "animate",
                  custom: i,
                  variants: {
                    initial: {
                      opacity: 0
                    },
                    animate: function animate(i) {
                      return isInView ? {
                        opacity: 1,
                        transition: {
                          delay: 0.35 + i * 0.08,
                          duration: 0.5
                        }
                      } : {
                        opacity: 0
                      };
                    }
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "pt-6 flex items-start",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "pt-[1px]",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                        src: "/icons/blue-success.svg",
                        alt: item.h2,
                        width: 16,
                        height: 16,
                        layout: "fixed"
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "text-p3Semibold pl-2 text-[#0D375B]",
                      children: [item.h2, ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: "text-p3Regular text-black",
                        children: item.h3
                      })]
                    })]
                  })
                }, item.h2) : /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                    className: "relative pt-6 flex items-start overflow-hidden",
                    initial: {
                      height: 0
                    },
                    animate: {
                      height: expand ? 'fit-content' : 0
                    },
                    transition: {
                      duration: 0.25,
                      ease: 'easeInOut'
                    },
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "relative pt-[1px]",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                        src: "/icons/blue-success.svg",
                        alt: item.h2,
                        width: 16,
                        height: 16,
                        layout: "fixed"
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "relative text-p3Semibold text-[#0D375B] pl-2",
                      children: [item.h2, ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: "text-p3Regular text-black",
                        children: item.h3
                      })]
                    })]
                  })
                }, item.h2);
              })
            })]
          }, usage.section);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "relative flex justify-center mt-5 md:hidden bg-[#F8F8F8]",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex w-fit",
          onClick: expandContent,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "text-p3Regular text-black",
            children: expand ? (0,translate/* translate2 */.n7)('ซ่อน', 'Hide', lang) : (0,translate/* translate2 */.n7)('อ่านเพิ่ม', 'More details', lang)
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "h-fit w-fit",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
              animate: animateChevron,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* ChevronDown */._M, {})
            })
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var Usage_Usage = (Usage);
var usages = [{
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
    src: "/icons/system1.svg",
    alt: "",
    width: 18.31,
    height: 13.71,
    layout: "fixed"
  }),
  customClass: 'md:mr-10 lg:w-[60%]',
  section: 'Section 9',
  sectionTH: 'มาตรา 9',
  detail: [{
    h2: 'Suitable for low-risk, general transactions',
    h3: 'such as internal organizational documents.'
  }, {
    h2: 'An electronic signature offers a lower level of trustworthiness compared to a digital signature.',
    h3: 'This is due to its reliance on image uploads or device-based signing, making it more susceptible to forgery and unauthorized alterations.'
  }],
  detailTH: [{
    h2: 'เหมาะสำหรับธุรกรรมทั่วไปที่มีความเสี่ยงต่ำ',
    h3: 'เช่น เอกสารบันทึกภายในขององค์กร'
  }, {
    h2: 'ระดับความน่าเชื่อถือต่ำกว่าลายมือชื่อดิจิทัล',
    h3: 'เนื่องจากเป็นเพียงการอัปโหลดรูปเข้าระบบหรือเซ็นชื่อผ่านอุปกรณ์ทำให้การปลอมแปลงลายมือชื่อทำได้ง่าย'
  }]
}, {
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
    src: "/icons/system2.svg",
    alt: "",
    width: 18.31,
    height: 18.29,
    layout: "fixed"
  }),
  customClass: 'mt-7 md:mt-0',
  section: 'Section 26 and 28',
  sectionTH: 'มาตรา 26 และ 28',
  detail: [{
    h2: 'Ideal for high-value or high-risk transactions',
    h3: 'like sales agreements, trade deals, and financial documents, ensuring security and legal enforceability.'
  }, {
    h2: 'Enables verification of any changes to signed documents,',
    h3: 'including alterations to signatures or content.'
  }, {
    h2: 'Implements reliable identity verification aligned with IAL 2 standards,',
    h3: 'ensuring authentication at AAL 2 level or higher to match transaction risk levels.',
    collapse: true
  }],
  detailTH: [{
    h2: 'เหมาะสำหรับธุรกรรมที่มีมูลค่าหรือความเสี่ยงสูง และมีภาระผูกพันตามสัญญา',
    h3: 'เช่น สัญญาซื้อขาย ข้อตกลงทางการค้า เอกสารการเงิน เป็นต้น'
  }, {
    h2: 'สามารถตรวจสอบการเปลี่ยนแปลงของเอกสารที่ผ่านการลงลายมือชื่อได้',
    h3: 'ไม่ว่าจะเป็นการเปลี่ยนแปลงของลายมือชื่อหรือข้อความบนเอกสาร'
  }, {
    h2: 'มีขั้นตอนการพิสูจน์ตัวตนที่น่าเชื่อถือและเหมาะสมกับระดับความเสี่ยงของธุรกรรม',
    h3: 'หรือที่ระดับ IAL 2 และมีการยืนยันตัวตนที่ระดับ AAL 2 ขึ้นไป',
    collapse: true
  }]
}];
;// CONCATENATED MODULE: ./components/eSignature/Usage/index.ts

// EXTERNAL MODULE: ./node_modules/react-intersection-observer/dist/index.mjs
var dist = __webpack_require__(8357);
;// CONCATENATED MODULE: ./components/eSignature/PointerSection/PointerSection.tsx










var PointerSection = function PointerSection() {
  var _useInView = (0,dist/* useInView */.YD)({
    threshold: 0.5,
    triggerOnce: true
  }),
      ref = _useInView.ref,
      inView = _useInView.inView;

  var _useTailwindBreakpoin = (0,TailwindBreakpointContext/* useTailwindBreakpoint */._)(),
      screenWidth = _useTailwindBreakpoin.screenWidth;

  var _useState = (0,react.useState)(null),
      initWidth = _useState[0],
      setInitWidth = _useState[1];

  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang;

  var _useState2 = (0,react.useState)(false),
      isHovering = _useState2[0],
      setIsHovered = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      noCursor = _useState3[0],
      setNoCursor = _useState3[1];

  (0,react.useEffect)(function () {
    var cursorQuery = window.matchMedia('(pointer: coarse)');
    setNoCursor(cursorQuery.matches);
  }, []);
  (0,react.useEffect)(function () {
    setInitWidth(window.innerWidth);
  }, []);
  (0,react.useEffect)(function () {
    if (screenWidth) {
      setInitWidth(null);
    }
  }, [screenWidth]);

  var onMouseEnter = function onMouseEnter() {
    return setIsHovered(true);
  };

  var onMouseLeave = function onMouseLeave() {
    return setIsHovered(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    id: "pointer",
    className: initWidth >= 1024 || screenWidth >= 1024 ? 'Container' : 'px-4 md:px-12',
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      ref: ref,
      className: "relative flex justify-center min-h-[340px] bg-blue-50 rounded-[30px] items-center p-5 md:p-10 lg:mx-2",
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "absolute rounded-tl-[30px] overflow-hidden top-0 left-0",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          className: "rounded-tl",
          src: "images/e-signature/question-mark.svg",
          alt: "",
          width: 230,
          height: 340
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative flex flex-col lg:flex-row justify-center items-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "lg:w-[70%] lg:px-9",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.h1 */.E.h1, {
            className: "text-center md:text-start text-h6Semibold gradient-head lg:-ml-4",
            initial: {
              opacity: 0,
              y: 20
            },
            animate: inView ? {
              opacity: 1,
              y: 0
            } : {
              opacity: 0,
              y: 20
            },
            viewport: {
              amount: 0.5,
              once: true
            },
            transition: {
              duration: 1,
              delay: 0.3
            },
            children: lang === 'en' ? /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "Why select CODIUM's e-Signature service?"
            }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              children: ["\u0E17\u0E33\u0E44\u0E21\u0E04\u0E27\u0E23\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E43\u0E0A\u0E49 e-Signature", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
                className: "md:hidden"
              }), " \u0E01\u0E31\u0E1A\u0E42\u0E04\u0E40\u0E14\u0E35\u0E22\u0E21?"]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(motion/* motion.ul */.E.ul, {
            role: "list",
            className: "list-disc pt-5 text-p3Regular marker:text-[10px] pl-4 md:pl-0",
            initial: {
              opacity: 0
            },
            animate: inView ? {
              opacity: 1
            } : {
              opacity: 0
            },
            viewport: {
              amount: 0.5,
              once: true
            },
            transition: {
              duration: 1,
              delay: 0.5
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              className: "pb-2",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "text-p3Semibold text-lightBlue",
                children: "One-Stop Service:"
              }), ' ', lang == 'en' ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: "We provide comprehensive solutions for businesses of all sizes, from emerging startups to established enterprises, with a deep understanding of real business needs."
              }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: ["\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E15\u0E2D\u0E1A\u0E42\u0E08\u0E17\u0E22\u0E4C\u0E17\u0E38\u0E01\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 \u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E08\u0E30\u0E40\u0E1B\u0E47\u0E19\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E02\u0E19\u0E32\u0E14\u0E40\u0E25\u0E47\u0E01\u0E17\u0E35\u0E48\u0E01\u0E33\u0E25\u0E31\u0E07\u0E40\u0E15\u0E34\u0E1A\u0E42\u0E15 \u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E02\u0E19\u0E32\u0E14\u0E43\u0E2B\u0E0D\u0E48\u0E17\u0E35\u0E48\u0E21\u0E35\u0E1E\u0E19\u0E31\u0E01\u0E07\u0E32\u0E19\u0E2B\u0E25\u0E32\u0E22\u0E1E\u0E31\u0E19\u0E04\u0E19", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "text-p3Semibold text-lightBlue",
                  children: "\u0E40\u0E02\u0E49\u0E32\u0E43\u0E08\u0E16\u0E36\u0E07\u0E04\u0E27\u0E32\u0E21\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E41\u0E17\u0E49\u0E08\u0E23\u0E34\u0E07"
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              className: "text-p3Semibold pb-2",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: " text-lightBlue",
                children: "Flexible & Versatile:"
              }), ' ', lang == 'en' ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: "Beyond our electronic signature system, we offer a suite of integrated solutions designed to streamline and transform your organization's workflow."
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: "\u0E19\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E23\u0E30\u0E1A\u0E1A\u0E25\u0E07\u0E25\u0E32\u0E22\u0E21\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E2D\u0E34\u0E40\u0E25\u0E47\u0E01\u0E17\u0E23\u0E2D\u0E19\u0E34\u0E01\u0E2A\u0E4C\u0E41\u0E25\u0E49\u0E27 \u0E40\u0E23\u0E32\u0E22\u0E31\u0E07\u0E21\u0E35\u0E23\u0E30\u0E1A\u0E1A\u0E2D\u0E37\u0E48\u0E19\u0E46\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E17\u0E33\u0E07\u0E32\u0E19\u0E23\u0E48\u0E27\u0E21\u0E01\u0E31\u0E19 \u0E21\u0E32\u0E0A\u0E48\u0E27\u0E22 Transform \u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E40\u0E15\u0E47\u0E21\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              className: "pb-2",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "text-p3Semibold text-lightBlue",
                children: "Professional Team:"
              }), ' ', lang == 'en' ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: "Our experienced experts have supported leading private enterprises, international organizations, and government agencies, showcasing our proven expertise and reliability."
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: "\u0E0A\u0E48\u0E27\u0E22\u0E43\u0E2B\u0E49\u0E04\u0E33\u0E1B\u0E23\u0E36\u0E01\u0E29\u0E32\u0E41\u0E01\u0E48\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E21\u0E32\u0E41\u0E25\u0E49\u0E27\u0E01\u0E27\u0E48\u0E32\u0E23\u0E49\u0E2D\u0E22\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23 \u0E17\u0E31\u0E49\u0E07\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E40\u0E2D\u0E01\u0E0A\u0E19\u0E43\u0E19\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28, \u0E15\u0E48\u0E32\u0E07\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28 \u0E41\u0E25\u0E30\u0E2B\u0E19\u0E48\u0E27\u0E22\u0E07\u0E32\u0E19\u0E23\u0E32\u0E0A\u0E01\u0E32\u0E23"
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
          className: "flex ".concat(isHovering || noCursor ? 'lg:filter-none' : 'lg:grayscale'),
          initial: {
            opacity: 0,
            scale: 1
          },
          animate: inView ? {
            opacity: 1,
            scale: [1, 1.2, 1],
            transition: {
              type: 'spring',
              delay: 0.5,
              duration: 1
            }
          } : {
            opacity: 0,
            scale: 1
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: lang === 'en' ? 'images/e-signature/pointer-eng.webp' : 'images/e-signature/pointer.webp',
            alt: "\u0E15\u0E2D\u0E1A\u0E42\u0E08\u0E17\u0E22\u0E4C\u0E17\u0E38\u0E01\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E32\u0E23\u0E14\u0E49\u0E27\u0E22 e-signature",
            width: 460,
            height: 276
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var PointerSection_PointerSection = (PointerSection);
;// CONCATENATED MODULE: ./components/eSignature/PointerSection/index.ts

;// CONCATENATED MODULE: ./components/eSignature/Service/Service.tsx





var Service = function Service(_ref) {
  var h2 = _ref.h2,
      paragraph = _ref.paragraph,
      animation = _ref.animation;

  var _useInView = (0,dist/* useInView */.YD)({
    threshold: 0.5,
    triggerOnce: true
  }),
      ref = _useInView.ref,
      inView = _useInView.inView;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    className: "w-full md:mx-2 mb-4 rounded bg-[#0D375B] py-5 px-2 md:px-4",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative w-fit h-fit flex justify-center mx-auto py-2 mb-5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "relative w-[173px] h-[173px] rounded-full bg-[#182A3B]"
      }), animation]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "text-white text-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.h2 */.E.h2, {
        className: "pb-5 text-p2Semibold",
        initial: {
          opacity: 0,
          y: 20
        },
        animate: inView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        },
        viewport: {
          amount: 0.5,
          once: true
        },
        transition: {
          duration: 1,
          delay: 0.3
        },
        children: h2
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.p */.E.p, {
        className: "text-p3Regular text-white",
        initial: {
          opacity: 0
        },
        animate: inView ? {
          opacity: 1
        } : {
          opacity: 0
        },
        viewport: {
          amount: 0.5,
          once: true
        },
        transition: {
          duration: 1,
          delay: 0.5
        },
        children: paragraph
      })]
    })]
  });
};

/* harmony default export */ var Service_Service = (Service);
;// CONCATENATED MODULE: ./components/eSignature/ServiceSection/ServiceAnimation1/ServiceAnimation1.tsx






var ServiceAnimation1 = function ServiceAnimation1() {
  var _useInView = (0,dist/* useInView */.YD)({
    threshold: 0.5,
    triggerOnce: true
  }),
      ref = _useInView.ref,
      inView = _useInView.inView;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
      className: "absolute -left-[35px]",
      initial: {
        opacity: 0,
        scale: 0
      },
      animate: inView ? {
        opacity: 1,
        scale: [0, 1],
        transition: {
          type: 'spring',
          delay: 0.3,
          duration: 0.5
        }
      } : {
        opacity: 0,
        scale: 1
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: "/images/e-signature/labtop.png",
        alt: "",
        width: 243,
        height: 173,
        layout: "fixed"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
      className: "absolute w-fit top-[22px] -left-[32px]",
      initial: {
        opacity: 0,
        x: 11,
        y: -9
      },
      animate: inView ? {
        opacity: 1,
        x: 0,
        y: 0
      } : {
        opacity: 0,
        x: 11,
        y: -9
      },
      transition: {
        duration: 0.5,
        delay: 0.35,
        ease: 'easeIn'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: "/images/e-signature/diagram.png",
        alt: "",
        width: 95,
        height: 72,
        layout: "fixed"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
      className: "absolute w-fit top-[17px] left-[76px]",
      initial: {
        opacity: 0,
        scale: 0
      },
      animate: inView ? {
        opacity: 1,
        scale: [0, 1],
        transition: {
          type: 'spring',
          delay: 0.5,
          duration: 0.5
        }
      } : {
        opacity: 0,
        scale: 1
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: "/images/e-signature/cog.png",
        alt: "",
        width: 73,
        height: 78,
        layout: "fixed"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
      className: "absolute top-[84px] -right-[4px]",
      initial: {
        opacity: 0,
        x: 30,
        y: 21
      },
      animate: inView ? {
        opacity: 1,
        x: 0,
        y: 0
      } : {
        opacity: 0,
        x: 30,
        y: 21
      },
      transition: {
        duration: 1,
        delay: 0.8
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: "/images/e-signature/power.svg",
        alt: "",
        width: 72,
        height: 82,
        layout: "fixed"
      })
    })]
  });
};

/* harmony default export */ var ServiceAnimation1_ServiceAnimation1 = (ServiceAnimation1);
;// CONCATENATED MODULE: ./components/eSignature/ServiceSection/ServiceAnimation2/ServiceAnimation2.tsx






var ServiceAnimation2 = function ServiceAnimation2() {
  var _useInView = (0,dist/* useInView */.YD)({
    threshold: 0.5,
    triggerOnce: true
  }),
      ref = _useInView.ref,
      inView = _useInView.inView;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "absolute h-[116.92px] top-[44px] left-[44px]",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: "/images/e-signature/api-box.svg",
        alt: "",
        width: 83.79,
        height: 116.92,
        layout: "fixed",
        priority: true
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        className: "absolute top-0 w-full bg-[#182A3B]",
        initial: {
          opacity: 1,
          height: '100%'
        },
        animate: inView ? {
          opacity: 0,
          height: 0
        } : {
          opacity: 1,
          height: '100%'
        },
        transition: {
          duration: 1,
          delay: 0.3
        }
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
      className: "absolute w-fit top-[3px] left-[40px]",
      initial: {
        opacity: 0,
        scale: 0,
        top: 40,
        left: 35
      },
      animate: inView ? {
        opacity: 1,
        scale: [0, 1],
        top: 3,
        left: 40,
        transition: {
          type: 'spring',
          delay: 0.3,
          duration: 1
        }
      } : {
        opacity: 0,
        scale: 1
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-fit",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "/images/e-signature/api-cloud.svg",
          alt: "",
          width: 111.75,
          height: 93.56,
          layout: "fixed"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        className: "absolute w-fit top-[34px] left-[21px]",
        initial: {
          opacity: 1
        },
        animate: inView ? {
          opacity: [0.9, 1, 0.9],
          transition: {
            duration: 0.5,
            delay: 1.3,
            loop: Infinity
          }
        } : {
          opacity: 1
        },
        exit: {
          opacity: 1
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "/images/e-signature/api-text.svg",
          alt: "",
          width: 36.18,
          height: 35.26,
          layout: "fixed"
        })
      })]
    })]
  });
};

/* harmony default export */ var ServiceAnimation2_ServiceAnimation2 = (ServiceAnimation2);
;// CONCATENATED MODULE: ./components/eSignature/ServiceSection/ServiceSection.tsx
















var ServiceSection = function ServiceSection(_ref) {
  var click = _ref.click;

  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang;

  var router = (0,next_router.useRouter)();

  var _useTailwindBreakpoin = (0,TailwindBreakpointContext/* useTailwindBreakpoint */._)(),
      screenWidth = _useTailwindBreakpoin.screenWidth;

  var _useState = (0,react.useState)(null),
      initWidth = _useState[0],
      setInitWidth = _useState[1];

  var _useInView = (0,dist/* useInView */.YD)({
    threshold: 0.5,
    triggerOnce: true
  }),
      ref = _useInView.ref,
      inView = _useInView.inView;

  (0,react.useEffect)(function () {
    setInitWidth(window.innerWidth);
  }, []);
  (0,react.useEffect)(function () {
    if (screenWidth) {
      setInitWidth(null);
    }
  }, [screenWidth]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    id: "service",
    className: initWidth >= 1024 || screenWidth >= 1024 ? 'Container' : '',
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "px-4 md:px-12 lg:px-0 relative",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        className: "relative text-h5MobileBold lg:text-h5Bold gradient-head-large text-center py-8",
        children: lang === 'en' ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: "Start securing your organization today with CODIUM e-Signature"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E1B\u0E01\u0E1B\u0E49\u0E2D\u0E07\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49 \u0E14\u0E49\u0E27\u0E22 CODIUM e-Signature"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        ref: ref,
        className: "relative flex flex-col md:flex-row justify-center items-center pb-5",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
          className: "md:-ml-[5rem]",
          initial: {
            opacity: 0,
            scale: 0
          },
          animate: inView ? {
            opacity: 1,
            scale: [0, 1],
            transition: {
              type: 'spring',
              delay: 0.35,
              duration: 1
            }
          } : {
            opacity: 0,
            scale: 1
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/images/e-signature/windows.webp",
            alt: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E41\u0E25\u0E30\u0E25\u0E07\u0E19\u0E32\u0E21\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22\u0E14\u0E49\u0E27\u0E22 e-Signature",
            width: 601,
            height: 320
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "text-white md:w-[50%]",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "ml-auto w-fit",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.h2 */.E.h2, {
              className: "pb-5 text-p2Semibold",
              initial: {
                opacity: 0,
                x: 20
              },
              animate: inView ? {
                opacity: 1,
                x: 0
              } : {
                opacity: 0,
                x: 20
              },
              viewport: {
                amount: 0.5,
                once: true
              },
              transition: {
                duration: 1,
                delay: 0.3
              },
              children: (0,translate/* translate2 */.n7)('สร้างเอกสารอนุมัติและลงนามอย่างปลอดภัยด้วย e-Signature', 'Create approval documents and securely sign them with your electronic signature using our e-Signature system.', lang)
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.p */.E.p, {
              className: "text-p3Regular",
              initial: {
                opacity: 0
              },
              animate: inView ? {
                opacity: 1
              } : {
                opacity: 0
              },
              viewport: {
                amount: 0.5,
                once: true
              },
              transition: {
                duration: 1,
                delay: 0.5
              },
              children: lang === 'en' ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: ["Empower your document workflow securely with", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "text-p3Semibold text-lightBlue",
                  children: "e-Signature."
                }), ' ', "Generate approval requests and sign documents effortlessly with your electronic signature. Streamline approvals, ensure legal compliance, and eliminate paper-based processes for a more efficient and secure organization."]
              }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: ["\u0E17\u0E33\u0E43\u0E2B\u0E49\u0E01\u0E23\u0E30\u0E1A\u0E27\u0E19\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E41\u0E25\u0E30\u0E25\u0E07\u0E19\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E07\u0E48\u0E32\u0E22\u0E41\u0E25\u0E30\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E14\u0E49\u0E27\u0E22", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "text-p3Semibold text-lightBlue",
                  children: "e-Signature"
                }), ' ', "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E04\u0E33\u0E02\u0E2D\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E41\u0E25\u0E30\u0E25\u0E07\u0E19\u0E32\u0E21\u0E43\u0E19\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E23\u0E27\u0E14\u0E40\u0E23\u0E47\u0E27 \u0E25\u0E14\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E17\u0E35\u0E48\u0E22\u0E38\u0E48\u0E07\u0E22\u0E32\u0E01 \u0E41\u0E25\u0E30\u0E21\u0E31\u0E48\u0E19\u0E43\u0E08\u0E44\u0E14\u0E49\u0E27\u0E48\u0E32\u0E17\u0E38\u0E01\u0E25\u0E32\u0E22\u0E40\u0E0B\u0E47\u0E19\u0E21\u0E35\u0E1C\u0E25\u0E17\u0E32\u0E07\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22 \u0E19\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E19\u0E35\u0E49\u0E22\u0E31\u0E07\u0E0A\u0E48\u0E27\u0E22\u0E25\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E01\u0E23\u0E30\u0E14\u0E32\u0E29 \u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E27\u0E32\u0E21\u0E04\u0E25\u0E48\u0E2D\u0E07\u0E15\u0E31\u0E27\u0E43\u0E2B\u0E49\u0E01\u0E31\u0E1A\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23 \u0E41\u0E25\u0E30\u0E17\u0E33\u0E43\u0E2B\u0E49\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E07\u0E32\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E34\u0E08\u0E34\u0E17\u0E31\u0E25\u0E17\u0E35\u0E48\u0E21\u0E35\u0E1B\u0E23\u0E30\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E20\u0E32\u0E1E\u0E41\u0E25\u0E30\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22\u0E21\u0E32\u0E01\u0E22\u0E34\u0E48\u0E07\u0E02\u0E36\u0E49\u0E19"]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
              className: "mt-5 w-fit mx-auto lg:mx-0",
              initial: {
                opacity: 0
              },
              animate: inView ? {
                opacity: 1
              } : {
                opacity: 0
              },
              viewport: {
                amount: 0.5,
                once: true
              },
              transition: {
                duration: 1,
                delay: 0.6
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Common/* Button */.z, {
                id: "e-memo",
                icon: "/icons/speech.svg",
                text: (0,translate/* translate2 */.n7)('ติดต่อเรา', 'CONTACT US', lang),
                className: "text-sm border border-white",
                onClick: click
              })
            })]
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        className: "relative text-h5MobileBold lg:text-h5Bold gradient-head-large text-center py-8",
        children: lang === 'en' ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: "We offer an end-to-end e-Signature management platform."
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: ["\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E41\u0E04\u0E48 Digital Signing? ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
            className: "md:hidden"
          }), ' ', "\u0E40\u0E23\u0E32\u0E21\u0E35\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23 \u201Ce-Digital Signature\u201D"]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative flex flex-col md:flex-row justify-center pb-5",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Service_Service, {
          h2: (0,translate/* translate2 */.n7)('บริการ Digital Certificate Management', 'Digital Certificate Management Service', lang),
          paragraph: lang === 'en' ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Our professional dashboard simplifies Digital Certificate management\u2014easily create, delete, and revoke certificates while seamlessly executing digital signatures."
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "text-p3Semibold",
              children: "Dashboard"
            }), ' ', "\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E43\u0E1A\u0E23\u0E31\u0E1A\u0E23\u0E2D\u0E07\u0E2D\u0E34\u0E40\u0E25\u0E47\u0E01\u0E17\u0E23\u0E2D\u0E19\u0E34\u0E01\u0E2A\u0E4C (Digital Certificate)", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
              className: "hidden lg:block"
            }), "\u0E21\u0E35\u0E0A\u0E38\u0E14\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E48\u0E07\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E2A\u0E23\u0E49\u0E32\u0E07, \u0E25\u0E1A \u0E41\u0E25\u0E30\u0E16\u0E2D\u0E19\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E43\u0E1A\u0E23\u0E31\u0E1A\u0E23\u0E2D\u0E07", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
              className: "hidden lg:block"
            }), "\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E23\u0E35\u0E22\u0E01\u0E43\u0E0A\u0E49\u0E43\u0E1A\u0E23\u0E31\u0E1A\u0E23\u0E2D\u0E07\u0E43\u0E19\u0E01\u0E32\u0E23\u0E25\u0E07\u0E25\u0E32\u0E22\u0E21\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E14\u0E34\u0E08\u0E34\u0E17\u0E31\u0E25 (Digital Signature) \u0E44\u0E14\u0E49"]
          }),
          animation: /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceAnimation1_ServiceAnimation1, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Service_Service, {
          h2: (0,translate/* translate2 */.n7)('บริการ Digital Signing API Integration', 'Digital Signing API Integration Service', lang),
          paragraph: lang === 'en' ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "For organizations with existing document management systems, we offer an API solution or backend integration for seamless digital signing. Our service enables document signing without disrupting your current workflow."
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: ["\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E17\u0E35\u0E48\u0E21\u0E35", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "text-p3Semibold",
              children: "\u0E23\u0E30\u0E1A\u0E1A\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27 \u0E41\u0E25\u0E30\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E07\u0E19\u0E32\u0E21\u0E14\u0E49\u0E27\u0E22\u0E25\u0E32\u0E22\u0E21\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E14\u0E34\u0E08\u0E34\u0E17\u0E31\u0E25"
            }), ' ', "(Digital Signature) \u0E40\u0E23\u0E32\u0E21\u0E35\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "text-p3Semibold",
              children: "API Solution"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
              className: "lg:hidden"
            }), " \u0E2B\u0E23\u0E37\u0E2D", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "text-p3Semibold",
              children: "\u0E23\u0E30\u0E1A\u0E1A\u0E2B\u0E25\u0E31\u0E07\u0E1A\u0E49\u0E32\u0E19"
            }), "\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E23\u0E30\u0E1A\u0E1A\u0E40\u0E14\u0E34\u0E21\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48 \u0E41\u0E25\u0E30\u0E19\u0E33\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E17\u0E35\u0E48\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E23\u0E30\u0E1A\u0E1A\u0E21\u0E32\u0E17\u0E33\u0E01\u0E32\u0E23\u0E25\u0E07\u0E25\u0E32\u0E22\u0E21\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E2D\u0E34\u0E40\u0E25\u0E47\u0E01\u0E17\u0E23\u0E2D\u0E19\u0E34\u0E01\u0E2A\u0E4C\u0E44\u0E14\u0E49", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u0E0A\u0E48\u0E27\u0E22\u0E43\u0E2B\u0E49\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E25\u0E07\u0E19\u0E32\u0E21\u0E1A\u0E19\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E44\u0E14\u0E49\u0E42\u0E14\u0E22", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "text-p3Semibold",
              children: "\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19\u0E41\u0E1A\u0E1A\u0E40\u0E14\u0E34\u0E21"
            })]
          }),
          animation: /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceAnimation2_ServiceAnimation2, {})
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "relative pb-10 w-fit mx-auto",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Common/* Button */.z, {
          id: "contact-us-esignature-service",
          icon: "/icons/speech.svg",
          text: (0,translate/* translate2 */.n7)('ติดต่อเรา', 'CONTACT US', lang),
          className: "text-sm border border-white",
          onClick: click
        })
      })]
    })
  });
};

/* harmony default export */ var ServiceSection_ServiceSection = (ServiceSection);
;// CONCATENATED MODULE: ./components/eSignature/ServiceSection/index.ts

// EXTERNAL MODULE: ./models/conent.ts
var conent = __webpack_require__(3290);
;// CONCATENATED MODULE: ./components/eSignature/CustomerSection/CustomerSection.tsx







var CustomerSection = function CustomerSection(_ref) {
  var contents = _ref.contents;

  var _useInView = (0,dist/* useInView */.YD)({
    threshold: 0.5,
    triggerOnce: true
  }),
      ref = _useInView.ref,
      inView = _useInView.inView;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    id: "e-signature-customer",
    className: "Container relative w-full",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "Container relative text-h5MobileBold lg:text-h5Bold gradient-head text-center pt-10 pb-2",
      children: "TRUSTED BY"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      ref: ref,
      className: "grid grid-cols-3 lg:grid-cols-4 gap-x-4 md:gap-x-10 lg:px-48",
      children: contents === null || contents === void 0 ? void 0 : contents.map(function (logo, i) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
          className: "p-4 self-center max-w-[7rem] md:max-w-[9rem] last:col-start-2 lg:last:col-auto mx-auto",
          initial: "initial",
          animate: "animate",
          custom: i,
          variants: {
            initial: {
              opacity: 0,
              y: 20
            },
            animate: function animate(i) {
              return inView ? {
                opacity: 1,
                y: 0,
                transition: {
                  delay: 0.35 + i * 0.08,
                  duration: 0.5
                }
              } : {
                opacity: 0,
                y: 20
              };
            }
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "h-auto w-full",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: "".concat(conent.be).concat(logo.url),
              alt: logo.alt,
              width: logo.width,
              height: logo.height
            })
          })
        }, i);
      })
    })]
  });
};

/* harmony default export */ var CustomerSection_CustomerSection = (CustomerSection);
;// CONCATENATED MODULE: ./components/eSignature/CustomerSection/index.ts

// EXTERNAL MODULE: ./components/Contexts/HomeContext.tsx
var HomeContext = __webpack_require__(4269);
// EXTERNAL MODULE: ./components/NewsFeedSection/NewsFeedSection.tsx + 3 modules
var NewsFeedSection = __webpack_require__(6598);
;// CONCATENATED MODULE: ./components/Contexts/ESignatureContext.tsx

var ESignatureContext = /*#__PURE__*/(0,react.createContext)({
  customers: [],
  highlightBlogs: []
});
var useESignatureContext = function useESignatureContext() {
  return useContext(ESignatureContext);
};
// EXTERNAL MODULE: ./components/shared/FormContact.tsx + 7 modules
var FormContact = __webpack_require__(7878);
;// CONCATENATED MODULE: ./pages/e-signature.tsx
















var __N_SSG = true;

var ESignature = function ESignature(state) {
  var _useState = (0,react.useState)(false),
      scroll = _useState[0],
      setScroll = _useState[1];

  var scrollToContact = function scrollToContact() {
    setScroll(!scroll);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(header/* default */.Z, {
      content: {
        title: 'e-Signature by CODIUM - เซ็นเอกสารดิจิทัลอย่างถูกกฎหมาย',
        content: 'CODIUM e-Signature ระบบเซ็นเอกสารดิจิทัลที่ปลอดภัย ถูกกฎหมาย 100% ช่วยให้การทำงานสะดวก รวดเร็ว และลดการใช้กระดาษ รองรับการทำงานได้ทุกที่ ทุกเวลา',
        image: null
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ESignatureContext.Provider, {
      value: state,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(HomeContext/* HomeContext.Provider */.Q.Provider, {
        value: state,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProductDefinitionSection_ProductDefinitionSection, {
          click: scrollToContact
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "w-full h-fit bg-white",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CompareSection_CompareSection, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Usage_Usage, {})]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-full h-fit bg-white py-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(PointerSection_PointerSection, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-full h-fit bg-darkBlue",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceSection_ServiceSection, {
            click: scrollToContact
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-full h-fit bg-white pb-5",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CustomerSection_CustomerSection, {
            contents: state.customers
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-full h-fit bg-white pb-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewsFeedSection/* default */.Z, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-full h-fit text-white",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContact/* default */.Z, {
            product: "E-SIGNATURE",
            event: "e-signatureFormSubmit",
            scroll: scroll
          })
        })]
      })
    })]
  });
};

ESignature.getLayout = function (page) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* Layout */.A, {
    children: page
  });
};

/* harmony default export */ var e_signature = (ESignature);

/***/ }),

/***/ 4527:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/e-signature",
      function () {
        return __webpack_require__(4325);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6146:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"filterBackground":"ProductDefinitionSection_filterBackground__B6lrX"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [735,859,467,60,5,878,987,774,888,179], function() { return __webpack_exec__(4527); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);